// Generated by purs version 0.15.15
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ring from "../Data.Ring/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
var zero = function (dict) {
    return dict.zero;
};
var sub = function (dict) {
    return dict.sub;
};
var scaleIntNumber = {
    scale: /* #__PURE__ */ (function () {
        var $25 = Data_Semiring.mul(Data_Semiring.semiringNumber);
        return function ($26) {
            return $25(Data_Int.toNumber($26));
        };
    })()
};
var scaleIntInt = {
    scale: /* #__PURE__ */ Data_Semiring.mul(Data_Semiring.semiringInt)
};
var scale = function (dict) {
    return dict.scale;
};
var negate = function (dictAdditive) {
    var sub1 = sub(dictAdditive);
    var zero1 = zero(dictAdditive);
    return function (n) {
        return sub1(zero1)(n);
    };
};
var additiveNumber = {
    zero: 0.0,
    add: /* #__PURE__ */ Data_Semiring.add(Data_Semiring.semiringNumber),
    sub: /* #__PURE__ */ Data_Ring.sub(Data_Ring.ringNumber)
};
var additiveInt = {
    zero: 0,
    add: /* #__PURE__ */ Data_Semiring.add(Data_Semiring.semiringInt),
    sub: /* #__PURE__ */ Data_Ring.sub(Data_Ring.ringInt)
};
var add = function (dict) {
    return dict.add;
};
var sum = function (dictFoldable) {
    var foldl = Data_Foldable.foldl(dictFoldable);
    return function (dictAdditive) {
        return foldl(add(dictAdditive))(zero(dictAdditive));
    };
};
var abs = function (dictOrd) {
    var lessThan = Data_Ord.lessThan(dictOrd);
    return function (dictAdditive) {
        var zero1 = zero(dictAdditive);
        var negate1 = negate(dictAdditive);
        return function (x) {
            var $24 = lessThan(x)(zero1);
            if ($24) {
                return negate1(x);
            };
            return x;
        };
    };
};
export {
    add,
    scale,
    sub,
    zero,
    negate,
    sum,
    abs,
    additiveInt,
    scaleIntInt,
    additiveNumber,
    scaleIntNumber
};
